import { loadKitchensData } from "@prmf/site-data";
import { LoaderFunctionArgs } from "@remix-run/node";
import { ShouldRevalidateFunctionArgs } from "@remix-run/react";
import { session } from "@prmf/cloud-utils/cookies.server";
export { KitchenList as default } from "@prmf/site-screens";

export async function loader({ request }: LoaderFunctionArgs) {
  const cookie = await session.parse(request.headers.get("Cookie"));
  const kitchens = await loadKitchensData();

  if (cookie?.customerType === "social") kitchens.reverse();
  return { kitchens };
}

export function shouldRevalidate({
  defaultShouldRevalidate,
  formAction,
}: ShouldRevalidateFunctionArgs) {
  if (formAction === "/account/moodboard") return false;
  return defaultShouldRevalidate;
}
